import { Spinner, Stack } from "react-bootstrap";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ServiceManager } from "../../../../services/ServiceManager";
import { APIStatusCode } from "../../../../app/enums";
import { handleApiErrors } from "../../../../app/common/helper/ApiError";
import MISButton from "../../../../components/button";

interface DeleteExtractClientModalProps {
    establishmentId: string | undefined;
    configurationId: number;
    tableQueryKey: string;
    onClose: () => void;
}

export default function DeleteExtractClientModal({ establishmentId, configurationId, tableQueryKey, onClose }: DeleteExtractClientModalProps) {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: () => {
            return ServiceManager.ConfigurationService.DeleteConfigurations(establishmentId, configurationId);
        },
        onError: () => { },
        onSuccess: (data) => {
            if (data === null) {
                ServiceManager.ToastService.showError("Unable to delete extract client.");
            } else {
                if (data.status === APIStatusCode.NoContent) {
                    ServiceManager.ToastService.showSuccess("Extract Client deleted successfully.");
                    queryClient.invalidateQueries({ queryKey: [tableQueryKey] });
                    onClose();
                } else {
                    handleApiErrors(data, ServiceManager.ToastService);
                }
            }
        }
    });

    return (
        <Stack>
            <p className="heading text-center mt-2">Delete Extract Client</p>
            <p className="text-center">Are you sure you wish to delete this Extract Client? This will also delete associated User Type, Transform and Override data. This action cannot be undone.</p>
            {
                !mutation.isPending
                    ? (<Stack direction="horizontal" className="mt-3">
                        <MISButton text="Cancel" className="popup-btn right-margin10 btn btn-outline-secondary w-50" FnOnClick={onClose} />
                        <MISButton text="Delete" className="popup-btn right-margin10 btn btn-danger w-50" FnOnClick={() => { mutation.mutate(); }} />
                    </Stack>
                    ) : (
                        <div className="d-flex justify-content-center mt-3">
                            <Spinner animation="border" variant="info" role="status" />
                        </div>
                    )
            }
        </Stack>
    );
}
